import type { ServicesManager } from '@wix/services-manager/types'
import type { IExternalServicesLoader } from './types'
import { addServicesIfMissing } from './createServicesManager'

/**
 * Wire dynamically-loaded external services into a `ServicesManager`:
 * subscribe to services loaded after creation, and add any already-pending ones.
 * Each service is added only if its definition isn't already registered.
 * Returns an `unsubscribe` cleanup function (or `undefined` when no loader is supplied).
 */
export const setupExternalServices = async (
	servicesManager: ServicesManager,
	externalServicesLoader?: IExternalServicesLoader
): Promise<(() => void) | undefined> => {
	if (!externalServicesLoader) {
		return
	}

	// Subscribe to dynamically loaded external services
	const unsubscribe = externalServicesLoader.subscribeToExternalServices?.((externalService) => {
		addServicesIfMissing(servicesManager, [externalService])
	})

	// Load any pending external services that were loaded before subscription
	const pendingServices = await externalServicesLoader.loadExternalServices()
	addServicesIfMissing(servicesManager, pendingServices)

	return unsubscribe
}
